var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('Head',{attrs:{"headTitle":_vm.headTitle}}),_c('img',{staticClass:"img_brid img_brid1",attrs:{"src":require("../assets/imgs/brid.gif"),"alt":""}}),_c('img',{staticClass:"img_brid img_brid2",attrs:{"src":require("../assets/imgs/brid.gif"),"alt":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }